import React from 'react';
import config from '../config';

const RHCAHosur = () => {
  return (  
    <>
     <section className="page-header">
    <div className="page-header-bg" style={{backgroundImage: "url(assets/images/backgrounds/hosur1894-434.jpg)"}}>
    </div>
    <div className="container">
        <div className="page-header__inner">
            <h2>RHCA - Hosur</h2>
            <ul className="thm-breadcrumb list-unstyled">
                <li><a href="/">Home</a></li>
                <li><span>/</span></li>
                <li>RHCA - Hosur </li>
            </ul>
        </div>
    </div>
</section>

{/* Blog Details Start */}
<section className="blog-details">
    <div className="container">
        <div className="row justify-content-center">
            <div className="col-xl-8 col-lg-7">
                <div className="blog-details__left">
                    <div className="blog-details__img">
                        <img src="assets/images/blog/hosur770-427.jpg" alt="" />
                        
                    </div>
                    <div className="blog-details__content">
                       
                        <h3 className="blog-details__title">RHCA - Hosur </h3>
                        <p className="blog-details__text-1">
                           Ray of Hope Centre for Autism – Hosur is where our journey began, and it remains a warm, welcoming space for children and families. Our team of experienced therapists, educators, and specialists provide individualized support across ABA therapy, speech therapy, occupational therapy, special education, caregiver coaching, and group sessions. Every program is designed to honor each child’s unique developmental journey while involving families as true partners.
                        </p>
                        <p className="blog-details__text-2">
                            Serving the Hosur community for over a decade, our branch has become a trusted hub for inclusive, compassionate care. Here, children are encouraged to explore, learn, and thrive at their own pace, while families find guidance, reassurance, and a supportive network of professionals and fellow parents.
                        </p>
                        <p className="blog-details__text-2">
                            Seeing the high demand for quality autism support, our Hosur branch has grown over the years and continues to serve as a foundation for expansion. We are excited to announce that a new Ray of Hope Centre for Autism will be opening soon in Bangalore, allowing us to reach and support even more children and families.

                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
  <section className="contact-details">
        <div className="container">
          <div className="contact-details__inner">
            <div className="contact-details__inner-content">
              <div className="contact-details__shape-1 float-bob-y">
                <img src={`${config.baseUrl}/assets/images/shapes/contact-details-shape-1.png`} alt=""/>
              </div>
              <ul className="list-unstyled contact-details__list">
                <li>
                  <div className="icon">
                    <span className="icon-help"></span>
                  </div>
                  <div className="content">
                    <p>Have Question?</p>
                    <h4><a href="tel:04344255800;ext=878">04344 - 255800, 878</a></h4>
                  </div>
                </li>
                <li>
                  <div className="icon">
                    <span className="icon-mailbox"></span>
                  </div>
                  <div className="content">
                    <p>Write Email</p>
                    <h4><a href="mailto:rayofhope@acaindia.org">rayofhope@acaindia.org</a></h4>
                  </div>
                </li>
                <li>
                  <div className="icon">
                    <span className="icon-maps-and-flags"></span>
                  </div>
                  <div className="content">
                    <p>Visit Center</p>
                    <h4>Asian Christian Academy, Jeemangalam, Bagalur (P.O), Hosur, Krishnagiri (Dist.), Tamil Nadu - 635103</h4>
                  </div>
                </li>
                <li>
                  <div className="contact-details__social">
                    <a href="https://youtube.com/@rhca-india?si=Pu2jro4V4E-xB_l_" target='_blank'  rel="noopener noreferrer"><i class="fab fa-youtube"></i></a>
                                <a href="https://www.facebook.com/rayofhopeACA?mibextid=rS40aB7S9Ucbxw6v" target='_blank'  rel="noopener noreferrer"><i class="fab fa-facebook"></i></a>
                                <a href="https://www.linkedin.com/company/ray-of-hope-center-for-autism/" target='_blank'  rel="noopener noreferrer"><i class="fab fa-linkedin"></i></a>
                                <a href="https://www.instagram.com/rhcahosur?igsh=dmV5ZHA2czhsNWlv" target='_blank'  rel="noopener noreferrer"><i class="fab fa-instagram"></i></a>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
        <section className="google-map-two">
        <iframe
          title="Google Maps Location"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4564.419517784099!2d77.85394981123915!3d12.801320918535346!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae75a06b6b2723%3A0xb5a227888b778e75!2sRay%20of%20Hope%20Center%20for%20Autism!5e1!3m2!1sen!2sin!4v1753941805524!5m2!1sen!2sin"
          className="google-map__two" 
          allowFullScreen
        ></iframe>
      </section>
    </>
  );
};

export default RHCAHosur;